import {Component, OnInit} from '@angular/core';
import {FooterComponent} from '@app/layout/footer/footer.component';

@Component({
  selector: 'dcp-checkout-footer',
  templateUrl: './checkout-footer.component.html',
  styleUrls: ['./checkout-footer.component.scss']
})
export class CheckoutFooterComponent extends FooterComponent implements OnInit {
  /**
   * Names of the Nodes containing the links.
   */
  checkoutLegalLinksNode: string = 'CheckoutLegalLinksNode';

  ngOnInit() {
    super.ngOnInit();
  }
}
